import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { useMemo } from 'react';
import styled from 'styled-components';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollContainerWrapper = styled.div.withConfig({
  displayName: "FullHeightScrollContainer__ScrollContainerWrapper",
  componentId: "sc-1h3qre1-0"
})(["height:100%;word-break:break-word;> div{height:100%;}"]);
const StyledScrollContainer = styled.div.withConfig({
  displayName: "FullHeightScrollContainer__StyledScrollContainer",
  componentId: "sc-1h3qre1-1"
})(["position:relative;height:auto;width:100%;overflow-y:auto;"]);
const FullHeightScrollContainer = ({
  children,
  scrollContainerProps,
  scrollElementRef
}) => {
  const ScrollContainerProp = useMemo(() => {
    const StyledScrollContainerWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
      let {
          children: scrollContainerChildren
        } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);
      return /*#__PURE__*/_jsx(StyledScrollContainer, Object.assign({}, scrollContainerProps, rest, {
        ref: ref,
        children: scrollContainerChildren
      }));
    });
    StyledScrollContainerWrapper.displayName = 'StyledScrollContainerWrapper';
    return StyledScrollContainerWrapper;
  }, [scrollContainerProps]);
  return /*#__PURE__*/_jsx(ScrollContainerWrapper, {
    children: /*#__PURE__*/_jsx(ScrollContainer, {
      ScrollContainer: ScrollContainerProp,
      scrollElementRef: scrollElementRef,
      children: children
    })
  });
};
export default FullHeightScrollContainer;